var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgVerification = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m23.464 10.916-1.11-.832a1.376 1.376 0 0 1-.429-1.588l.53-1.287a1.37 1.37 0 0 0-1.085-1.865l-1.388-.176a1.34 1.34 0 0 1-1.16-1.16l-.177-1.387a1.371 1.371 0 0 0-1.867-1.084l-1.287.53a1.38 1.38 0 0 1-1.59-.429L13.044.53a1.35 1.35 0 0 0-2.145 0l-.808 1.134a1.378 1.378 0 0 1-1.59.428l-1.286-.554A1.371 1.371 0 0 0 5.35 2.622L5.172 4.01a1.34 1.34 0 0 1-1.16 1.16l-1.389.176A1.37 1.37 0 0 0 1.538 7.21l.53 1.287c.227.554.05 1.21-.428 1.588l-1.11.857a1.348 1.348 0 0 0 0 2.143l1.134.832c.48.378.657 1.034.43 1.588l-.556 1.286a1.37 1.37 0 0 0 1.085 1.865l1.388.176a1.34 1.34 0 0 1 1.161 1.16l.177 1.387a1.371 1.371 0 0 0 1.866 1.084l1.287-.53a1.38 1.38 0 0 1 1.59.429l.858 1.108a1.35 1.35 0 0 0 2.144 0l.858-1.108a1.378 1.378 0 0 1 1.59-.429l1.287.53a1.371 1.371 0 0 0 1.866-1.084l.177-1.387a1.34 1.34 0 0 1 1.16-1.16l1.388-.176a1.37 1.37 0 0 0 1.086-1.865l-.53-1.287a1.377 1.377 0 0 1 .428-1.588l1.11-.857c.656-.529.656-1.588-.05-2.143z",
    fill: "#57C480"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.787 15.577a1.327 1.327 0 0 1-.984.423c-.372 0-.718-.14-.984-.423L7.4 13.014a1.525 1.525 0 0 1 0-2.057 1.326 1.326 0 0 1 1.942 0l1.435 1.52 3.883-4.054a1.326 1.326 0 0 1 1.942 0 1.525 1.525 0 0 1 0 2.056l-4.814 5.098z",
    fill: "#FFF"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVerification, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/verification.c0df0c35.svg";
export { ForwardRef as ReactComponent };